import * as axios from "~/utilities/axios"

/**
 * Update a parking ticket by objectId
 * @param {string} objectId objectId of ticket to update
 * @param {object} body Object of key/values to update on a ticket
 * @param {string} sessionToken Users session token
 */
export const update = (objectId, body, sessionToken) => {
  return axios
    .secure(sessionToken)
    .put(`/api/v1/parkingticket/class/${objectId}`, body)
    .then(res => res.data)
    .catch(axios.parseError)
}

/**
 * get a parking ticket by objectId
 * @param {string} objectId objectId of ticket to fetch
 * @param {string} sessionToken Users session token
 */
export const get = (objectId, sessionToken) => {
  return axios
  .secure(sessionToken)
  .get(`/api/v1/parkingticket/class/${objectId}`)
  .then(res => res.data)
  .catch(axios.parseError)
}

/**
 * get a parking ticket by ticketID + email (public, no session token).
 * Used for the PayNyc checkout refetch when the payer has no valid session
 * (guest / stale session). Backed by GET /api/v1/parkingticket/lookup-by-email.
 * @param {string} ticketID ticketID of ticket to fetch
 * @param {string} email Owning user's email
 */
export const getByTicketIDAndEmail = (ticketID, email) => {
  return axios
  .basic
  .get(`/api/v1/parkingticket/lookup-by-email`, {
    params: { ticketID, email }
  })
  .then(res => res.data)
  .catch(axios.parseError)
}

/**
 * get all of a users tickets with statuses we show in the dashboards
 * @param {string} sessionToken Users session token
 */
export const fetchAllParkingTickets = (sessionToken) => {
  return axios
  .secure(sessionToken)
  .get(`/api/v1/parkingticket/query/all`)
  .then(res => res.data.results)
  .catch(axios.parseError)
}

export const createEvidence  = (objectId, body, sessionToken) => {
  return axios
  .secure(sessionToken)
  .post(`/api/v1/parkingticket/create/ticketEvidence/${objectId}`, body)
  .then(res => res.data)
  .catch(axios.parseError)
}

export const getFightRobotTickets = (userId, batchNumber) => {
  return axios.basic
    .get(`api/v1/robotticket/?userId=${userId}&batchNumber=${batchNumber}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const fightRobotTickets = (userID, tickets) => {
  const body = {
    userID,
    tickets
  }
  return axios.basic
    .post(`${process.env.PARSE_DIR}/functions/FightUserTicket`, body)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const payRobotTickets = (userID, tickets) => {
  const body = {
    userID,
    tickets
  }
  return axios.basic
    .post(`${process.env.PARSE_DIR}/functions/PayUserTicket`, body)
    .then(res => res.data)
    .catch(axios.parseError)
}
